<template>
  <div class="container">
    <div class="report">
      <div class="report-title">
        <p>{{ $t('lang.sy.title') }}</p>
      </div>
      <div class="report-content scroll">
        <div class="report-content-item">
          <p>{{ $t('lang.sy.type1.title') }}</p>
          <el-input
            type="textarea"
            :rows="5"
            placeholder=" "
            v-model="objective"
          >
          </el-input>
        </div>
        <div class="report-content-item">
          <p>{{ $t('lang.sy.type2.title') }}</p>
          <el-input
            type="textarea"
            :rows="10"
            placeholder=" "
            v-model="process"
          >
          </el-input>
        </div>
        <div class="report-content-item">
          <p>{{ $t('lang.sy.type3.title') }}</p>
          <el-input
            type="textarea"
            :rows="15"
            placeholder=" "
            v-model="experiences"
          >
          </el-input>
        </div>
      </div>
      <div class="report-btns">
        <div class="btn" @click="submit">{{ $t('lang.sy.submit') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { report } from '@/api/experimentation/test'
export default {
  components: {},
  props: [],
  data() {
    return {
      objective: '',
      process: '',
      experiences: '',
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    submit() {
      if (!this.objective || !this.process || !this.experiences) {
        let type = ''
        if (!this.experiences) type = '心得体会'
        if (!this.process) type = '实验过程'
        if (!this.objective) type = '实验目的'
        this.$notify({
          type: 'warning',
          message: type + '不能为空！',
          duration: 1500,
          title: 'WARNING',
        })
        return
      }
      report({
        course_id: parseInt(window.localStorage.getItem('expId')),
        purpose: this.objective,
        content: this.process,
        experience: this.experiences,
      }).then((res) => {
        this.$notify({
          type: 'success',
          message: res.msg,
          duration: 1500,
          title: 'SUCCESS',
        })
        this.objective = ''
        this.process = ''
        this.experiences = ''
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  padding: 0 18.75%;
  padding-bottom: 5vh;
  font-size: 0.9375vw;
  color: #666666;
  .report {
    width: 100%;
    padding: 4vh 3.5vw;
    background: rgba(255, 255, 255, 0.6);
    display: flex;
    flex-direction: column;
    align-items: center;
    &-title {
      width: 100%;
      background-image: var(--report_title-bg);
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-content: center;
      color: white;
      font-size: 1.25vw;
      font-weight: bold;
      p {
        margin: 10px 0 15px;
      }
    }
    &-content {
      width: 98%;
      // height: 55vh;
      padding: 3vh;
      margin-top: 3vh;
      background: rgba(255, 255, 255, 0.95);
      p {
        padding-left: 20px;
        border-left: 5px solid var(--exp-color);
      }
    }
    &-btns {
      padding-top: 3vh;
      .btn {
        line-height: 1.5;
        padding: 1vh 3vw;
        border-radius: 25px;
      }
    }
  }
}
</style>